{
  "title": "Cloud of Daggers",
  "source": "Player's Handbook",
  "levelAndSchool": "2nd-level conjuration",
  "level": 2,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V, S, M (a sliver of glass)",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "You fill the air with spinning daggers in a cube 5 feet on each side, centered on a point you choose within range. A creature takes 4d4 slashing damage when it enters the spell’s area for the first time on a turn or starts its turn there.",
    "At Higher Levels. When you cast this spell using a spell slot of 3rd level or higher, the damage increases by 2d4 for each slot level above 2nd."
  ],
  "spellLists": ["bard", "sorcerer", "warlock", "wizard"]
}
